'use strict';

angular.module('referrals', ['ngAnimate', 'msUtility', 'msCore', 'translations', 'ui.router.default']).config(['$stateProvider', 'errorRouterProvider', function ($stateProvider, errorRouterProvider) {
  var errorRoutes = errorRouterProvider.buildRoutes();
  //wire the routes
  for (var index in errorRoutes) {
    if (errorRoutes.hasOwnProperty(index)) {
      var route = errorRoutes[index];
      if (route.hasOwnProperty('name')) {
        $stateProvider.state(route.name, route);
      }
    }
  }
  $stateProvider.state('referral', {
    url: '/:organization/:pc?group&returnurl',
    abstract: true,
    default: '.form',
    template: '<div ui-view></div>',
    data: {
      noAuth: true
    },
    params: {
      organization: {
        value: null
      },
      pc: {
        value: null,
        squash: true
      },
      group: {
        value: null
      },
      returnurl: {
        value: null
      }
    }
  }).state('referral.form', {
    url: '',
    templateUrl: 'referrals/pages/referral.html',
    controller: 'ReferralCtrl',
    controllerAs: 'vm',
    resolve: {
      user: ['msAuth', 'userSvc', function (msAuth, userSvc) {
        if (msAuth.isLoggedIn()) {
          return userSvc.getUser();
        }
        return null;
      }]
    }
  });
}]).run(['eventTrackingSvc', function (eventTrackingSvc) {
  eventTrackingSvc.init();
  // send pageviews to google analytics
  eventTrackingSvc.registerEventListeners();
}]).constant('context', 'referrals');